"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constants = __importStar(require("./constants"));
const SearchBuilder_1 = __importDefault(require("./SearchBuilder"));
class SearchQueryBuilder extends SearchBuilder_1.default {
    // --------------------------------- public methods ------------------------------------------------------------------
    getUrl() {
        const fields = this.getFilters()
            .concat(this.getFreeText())
            .concat(this.getFields())
            .concat(this.getSource())
            .concat(this.getCollapse())
            .concat(this.getInnerHits())
            .concat(this.getSort())
            .concat(this.getANDs())
            .concat(this.getSize())
            .concat(this.getAggregations())
            .concat(this.getBoost())
            .filter(field => field !== '');
        return `${this.props.config[constants.GuiContainer][constants.GuiTarget]}/${constants.SEARCH_ENDPOINT}${fields.length > 0 ? '?' + fields.sort().join('&') : ''}`;
    }
    // --------------------------------- private methods -----------------------------------------------------------------
    getFreeText() {
        return this.props.states.query !== ''
            ? `${this.props.config[constants.GuiContainer][constants.GuiVariable]}=${encodeURIComponent(this.props.states.query)}`
            : '';
    }
    getFields() {
        return (this.props.config[constants.GuiContainer][constants.GuiFields] || []).map(f => `${constants.FIELDS_PARAMETER}=${f}`);
    }
    getSource() {
        const sources = this.props.config[constants.GuiSource];
        return sources
            ? sources[constants.GuiFields].map(f => `${sources[constants.GuiVariable]}=${encodeURIComponent(f)}`)
            : [];
    }
    getAggregations() {
        const aggregations = this.props.config[constants.GuiAggregations];
        if (aggregations) {
            return aggregations[constants.GuiFields].flatMap((field) => {
                if (typeof field === 'string') {
                    return `${aggregations[constants.GuiVariable]}=${encodeURIComponent(field)}`;
                }
                else {
                    const aggregation = field;
                    const variable = aggregations[constants.GuiVariable];
                    const name = aggregation[constants.GuiName];
                    return [
                        `${variable}=${name}`,
                        `${variable}_${name}${constants.AGGREGATION_FIELD_SUFFIX}=${encodeURIComponent(aggregation[constants.GuiField])}`,
                    ]
                        .concat(this.getAggregationTerm(variable, aggregation))
                        .concat(this.getAggregationInclude(variable, aggregation))
                        .concat(this.getAggregationExclude(variable, aggregation));
                }
            });
        }
        else {
            return [];
        }
    }
    getCollapse() {
        const collapse = this.props.config[constants.GuiCollapse];
        return collapse ? `${collapse[constants.GuiVariable]}=${encodeURIComponent(collapse[constants.GuiField])}` : '';
    }
    getHitSource(hit, name) {
        const source = hit[constants.GuiSource];
        return source
            ? source[constants.GuiFields].map(field => `${name}${source[constants.GuiVariable] || '_s'}=${encodeURIComponent(field)}`)
            : [];
    }
    getHitSort(hit, name) {
        const sort = hit[constants.GuiSort];
        return sort
            ? sort[constants.GuiOrdering].map(s => `${name}${sort[constants.GuiVariable] ? sort[constants.GuiVariable] : '_o'}=${s[constants.GuiOrder] ||
                'asc'}:${encodeURIComponent(s[constants.GuiField])}`)
            : [];
    }
    getInnerHits() {
        const coll = this.props.config[constants.GuiCollapse];
        if (coll) {
            const inner = coll[constants.GuiInnerHits];
            if (inner) {
                const variable = inner[constants.GuiVariable];
                const innerHits = [];
                return inner[constants.GuiHits]
                    .flatMap((hit) => {
                    const name = `${variable}_${hit[constants.GuiName]}`;
                    const size = this.getHitSize(hit, name);
                    const source = this.getHitSource(hit, name);
                    const sorting = this.getHitSort(hit, name);
                    innerHits.push(encodeURIComponent(hit[constants.GuiName]));
                    return source.concat(size).concat(sorting);
                })
                    .concat(innerHits.map(field => `${variable}=${encodeURIComponent(field)}`));
            }
            else {
                return [];
            }
        }
        else {
            return [];
        }
    }
    validateMultiSelectANDs(property) {
        const t = property[constants.GuiTarget];
        return (property[constants.GuiMulti] &&
            property[constants.GuiCondition] === 'AND' &&
            this.props.states.filters[t] &&
            this.props.states.filters[t].length > 0);
    }
    getANDs() {
        return (this.props.config[constants.GuiGroups] || [])
            .flatMap((group) => group[constants.GuiProperties])
            .filter((property) => this.validateMultiSelectANDs(property) || this.validateInternalANDs(property))
            .map(p => `_and=${this.getPropertyField(p)}`);
    }
    getSort() {
        const sort = this.props.config[constants.GuiSort];
        return sort
            ? sort[constants.GuiOrdering].map(s => `${sort[constants.GuiVariable]}=${s[constants.GuiOrder] || 'asc'}:${encodeURIComponent(s[constants.GuiField])}`)
            : [];
    }
    getFilters() {
        return this.getStateFilters().concat(this.getCustomFilters());
    }
    getStateFilters() {
        return (this.props.config[constants.GuiGroups] || [])
            .flatMap((g) => g[constants.GuiProperties])
            .filter((p) => p[constants.GuiTarget] !== '')
            .flatMap((p) => { var _a; return this.getFilterName(p, !((_a = p[constants.GuiVisible]) !== null && _a !== void 0 ? _a : true)); });
    }
    getCustomFilters() {
        return Object.keys(this.props.states.customFilters)
            .filter(f => f && this.props.states.customFilters[f].length > 0)
            .flatMap(f => this.props.states.customFilters[f])
            .flatMap(f => f.key && f.values && f.values.map(v => `${f.key}=${encodeURIComponent(v)}`));
    }
    getFilterName(property, useDefaultValues) {
        return this.getStateFilterValues(property, useDefaultValues).map(p => `${this.getPropertyField(property)}=${encodeURIComponent(p)}`);
    }
    getSize() {
        const size = this.props.config[constants.GuiSize];
        return size ? `${encodeURIComponent(size[constants.GuiVariable])}=${size[constants.GuiValue]}` : '';
    }
    getBoost() {
        const boost = this.props.config[constants.GuiBoost] || [];
        return boost.map((b) => `_boost=${b[constants.GuiTarget]}^${b[constants.GuiValue]}`).join('&');
    }
    validateInternalANDs(property) {
        return (property[constants.GuiVisible] !== undefined &&
            property[constants.GuiVisible] === false &&
            property[constants.GuiCondition] === 'AND' &&
            property[constants.GuiVisible] !== undefined &&
            property[constants.GuiVisible] === false);
    }
    getHitSize(hit, name) {
        const size = hit[constants.GuiSize];
        return size ? `${name}${size[constants.GuiVariable] || '_z'}=${size[constants.GuiValue]}` : '';
    }
    getAggregationTerm(variable, aggregation) {
        return aggregation[constants.GuiTerm]
            ? `${variable}_${aggregation[constants.GuiName]}${constants.AGGREGATION_TERM_SUFFIX}=${aggregation[constants.GuiTerm]}`
            : '';
    }
    getAggregationInclude(variable, aggregation) {
        return (aggregation[constants.GuiInclude] || []).map(i => `${variable}_${aggregation[constants.GuiName]}${constants.AGGREGATION_INCLUDE_SUFFIX}=${i}`);
    }
    getAggregationExclude(variable, aggregation) {
        return (aggregation[constants.GuiExclude] || []).map(e => `${variable}_${aggregation[constants.GuiName]}${constants.AGGREGATION_EXCLUDE_SUFFIX}=${e}`);
    }
}
exports.default = SearchQueryBuilder;
